import axios from 'axios';
import { deleteCookie } from '@/utils/cookie'



class HttpRequest {
  defaults: Object
  constructor(options: any) {
    this.defaults = {
      baseUrl: ''
    }
    this.defaults = Object.assign(this.defaults, options)
  }
  interceptors(install: any) {
    install.interceptors.request.use(
      (config: any) => {
        // const token = location.hostname == 'localhost' ? 'bba33ca7042498ae3aa2bccdbdb247334db95576':localStorage.getItem('token')||'';
        const token = localStorage.getItem('token') || '';
        if (token) {// 判断是否存在token，如果存在的话，则每个http header都加上token
          config.headers.token = `${token}`;
        }
        config.withCredentials = true;
        return config;
      },
      (err: any) => {
        return Promise.reject(err);
      }
    );
    install.interceptors.response.use(
      (res: any) => {
        const { data, status } = res;
        const { code } = data || {}
        if (code == 500) {
          // localStorage.removeItem('token')
          // deleteCookie('PHPSESSID')
        }
        return data;
      },
      (err: any) => {
        return Promise.reject(err);
      }
    );
  }
  request(options: any) {
    options = Object.assign(this.defaults, options || {});
    const instance = axios.create(options)
    this.interceptors(instance)
    return instance
  }
}
const request = new HttpRequest({
  timeout: 50000,
  withCredentials: true, // 允许携带cookie
});
export const http = request.request({});
